import { useMemo } from 'react';
import { useSafeUrlState } from '@mews/framework';
import { RoutingRuleTriggerType } from '@mews-commander/data-access';
import {
    RoutingRulesListFilterSchemaKeys,
    RoutingRulesListFilterValues,
    routingRulesListUrlFilterSchema,
} from '../schemas/routingRulesListFilterSchema';

/**
 * Until FeatureFlag.granularRoutingRulesConditionsExtensionEnabled is finished we have two sets of filters
 *  - pageFilters and tableFilters. Table filters being extensions of page filters. Thus this hook is used on two places
 */
export const useRoutingRuleListFilterDefaultValues = (displayLegacy?: boolean): RoutingRulesListFilterValues => {
    const [search] = useSafeUrlState(routingRulesListUrlFilterSchema);

    return useMemo(() => {
        let timingArray = [
            RoutingRuleTriggerType.Continuous,
            RoutingRuleTriggerType.Legacy,
            RoutingRuleTriggerType.Recurring,
        ];

        if (displayLegacy) {
            timingArray = timingArray.filter((value) => value !== RoutingRuleTriggerType.Legacy);
        }

        return {
            [RoutingRulesListFilterSchemaKeys.Name]: undefined,
            [RoutingRulesListFilterSchemaKeys.Timing]: timingArray,
            [RoutingRulesListFilterSchemaKeys.Companies]: undefined,
            [RoutingRulesListFilterSchemaKeys.TravelAgencies]: undefined,
            [RoutingRulesListFilterSchemaKeys.Rates]: undefined,
            [RoutingRulesListFilterSchemaKeys.GuestProfiles]: undefined,
            [RoutingRulesListFilterSchemaKeys.Groups]: undefined,
            [RoutingRulesListFilterSchemaKeys.Reservations]: undefined,
            ...search,
        };
    }, [search, displayLegacy]);
};
